
import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import AlbumIcon from '@mui/icons-material/Album';
import CommentIcon from '@mui/icons-material/Comment';
import ArtistIcon from '@mui/icons-material/RecordVoiceOver';

const HomePage = React.lazy(() => import('./componenets/Home'));
const AlbumsPage = React.lazy(() => import('./componenets/music/Albums'));
const CommentsPage = React.lazy(() => import('./componenets/comment/Comments'));
const ArtistsPage = React.lazy(() => import('./componenets/artist/Artists'));

const Routes = [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
      isSettings: false,
      icon: HomeIcon,
      displayOrder: 1,
    },
    {
      path: '/albums',
      name: 'Albums',
      component: AlbumsPage,
      isSettings: true,
      icon: AlbumIcon,
      displayOrder: 3,
    },
    {
      path: '/comments',
      name: 'Comments',
      component: CommentsPage,
      isSettings: true,
      icon: CommentIcon,
      displayOrder: 4,
    },
    {
      path: '/artists',
      name: 'Artists',
      component: ArtistsPage,
      isSettings: true,
      icon: ArtistIcon,
      displayOrder: 2,
    },
  ];
  
  export default Routes;
  